<template>
  <div>
    <div class="dashboard__table-wrapper">
      <custom-table
        :title="title"
        :tableData="dataArray"
        :pagesCount="pagesCount"
        :paginationMethod="'fetchDatapoints'"
        :columns="columns"
        class="dashboard__table"
        :extLoading="loading"
      >
        <template slot="headerData">
          <div class="table__flex-header">
            <div class="table__title">{{ title }}</div>
            <div class="dashboard__flex-wrapper">
              <div class="table__relative-container">
                <fg-input
                  class="table__filter"
                  :placeholder="'Search'"
                  :value="filterInput"
                  style="width: 20em"
                  @change.native="changeFilter"
                ></fg-input>
                <p-button
                  size="sm"
                  style="line-height: 2.5; position: absolute; top: 0; right:0"
                  @click.native="onFilterClick"
                  >Search</p-button
                >
              </div>
              <div class="table__relative-container">
                <p-button
                  size="md"
                  class="ml-2 h-100"
                  @click.native="onResetFiltersClick"
                  >Reset</p-button
                >
              </div>
              <div v-if="exportService" class="table__relative-container">
                <p-button size="md" class="ml-2 h-100" @click.native="runExport"
                  >Export</p-button
                >
              </div>
            </div>
          </div>
        </template>
        <template slot="thead">
          <th>Id</th>
          <th>Patient id</th>
          <th>Filename</th>
          <th>Created</th>
          <!--th>Study id</th-->
          <!--th>Datatype</th-->
          <th>Updated</th>
          <th>Operations</th>
        </template>
        <template slot-scope="{ row }">
          <td>{{ row.id }}</td>
          <td>{{ row.patientid }}</td>
          <td>{{ row.filename }}</td>
          <td>{{ row.created_at }}</td>
          <!--td>{{ extractStudyId(row.study) }}</td-->
          <!--td>{{ row.datatype }}</td-->
          <td>{{ row.updated_at }}</td>
          <td>
            <div class="dashboard__options-col">
              <p-button
                size="sm"
                type="default"
                style="margin-right:10px"
                @click.native="onDetailsClick(row.id)"
                >Details</p-button
              >
              <drop-down tag="div" title="Options">
                <a class="dropdown-item" @click="modalToggle(row.id)">Delete</a>
              </drop-down>
            </div>
          </td>
        </template>
      </custom-table>
    </div>

    <scale-loader
      v-if="loadingDetails"
      :loading="true"
      height="50px"
      width="15px"
      class="mt-5"
    />
    <details-section v-else />
  </div>
</template>

<script>
import { apiError } from "@/util/ErrorMessage.js";
import CustomTable from "../customReusableComponents/CustomTable";
import DetailsSection from "../layout/dashboard/Details/DetailsSection";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";

export default {
  components: {
    CustomTable,
    DetailsSection,
    ScaleLoader
  },
  data() {
    return {
      title: "DATAPOINTS",
      columns: [
        "Id",
        "Created_At",
        "Study_Id",
        "Datatype",
        "Status",
        "Updated_At"
      ],
      loading: false,
      loadingDetails: false
    };
  },
  computed: {
    pagesCount() {
      const entries = this.$store.getters.getDatapointsQuantity;
      return Math.ceil(entries / 5);
    },
    dataArray() {
      const entries = this.$store.getters.datapoints;
      entries.map(item => {
        item.created_at = this.convertData(item.created_at);
        item.updated_at = this.convertData(item.updated_at);
      });
      return entries;
    },
    filterInput: {
      get: function() {
        return this.$store.getters.getStudiesFilter;
      }
    },
    exportService() {
      return this.$store.getters.getExportService;
    }
  },
  methods: {
    async onDetailsClick(id) {
      this.loadingDetails = true;

      try {
        await this.$store.dispatch("fetchDetails", id);
      } catch (error) {
        apiError(error, this);
      }

      this.loadingDetails = false;
    },
    convertData(data) {
      return new Date(data)
        .toDateString()
        .split(" ")
        .slice(1, 4)
        .join(" ");
    },
    modalToggle(id) {
      this.$store.dispatch("toggleModal");
      this.$store.dispatch("sendDatapointIdToModal", id);
    },
    runExport() {
      window.open(
        this.$store.getters.getExportService +
          "?token=" +
			  this.$store.getters.token +
			  "&userid=" +
			  this.$store.getters.userid
      );
    },
    async onFilterClick() {
      this.loading = true;

      let inputData = {
        page: 1
      };

      try {
        await this.$store.dispatch("fetchDatapoints", inputData);
      } catch (error) {
        apiError(error, this);
      }

      this.loading = false;
    },
    extractStudyId(url) {
      if (url) {
        const urlArray = url.split("/");
        const id = urlArray[urlArray.length - 2];
        return id;
      } else {
        return "N/A";
      }
    },
    changeFilter(e) {
      this.$store.dispatch("setStudiesFilter", e.target.value);
    },
    parseStudiesFilter(queryParam) {
      return queryParam.split("=")[1];
    },
    async onResetFiltersClick() {
      this.$store.dispatch("setStudiesFilter", "");

      this.loading = true;

      try {
        await this.$store.dispatch("fetchDatapoints", { page: 1 });
      } catch (error) {
        apiError(error, this);
      }

      this.loading = false;
    }
  },

  async created() {
    this.loading = true;

    try {
      await this.$store.dispatch("fetchDatapoints", {
        page: 1
      });
    } catch (error) {
      apiError(error, this);
    }

    this.loading = false;
  }
};
</script>
<style lang="scss" scoped>
.dashboard {
  &__table-wrapper {
    overflow: auto;
  }

  &__table {
    width: 100%;

    @media only screen and (min-width: 320px) and (max-width: 900px) {
      width: 800px;
    }

    @media only screen and (min-width: 990px) and (max-width: 1024px) {
      width: 800px;
    }
  }

  &__options-col {
    display: flex;
    align-items: center;
  }

  &__flex-wrapper {
    display: flex;
  }
}
</style>
